import EmailerBannerCreate from "./EmailerBannerCreate";
import EmailerBannerEdit from "./EmailerBannerEdit";
import EmailerBannerList from "./EmailerBannerList";

export default {
  create: EmailerBannerCreate,
  list: EmailerBannerList,
  edit: EmailerBannerEdit,
};
